import LocalizedTextField from '@components/Customization/LocalizedTextField';
import { useLocalization } from '@lib/localization';
import { type ReportText } from '@store/api/reportDesignEndpoints';
import FieldOrigin, { type BeneathSource } from './FieldOrigin';

interface Props {
  label: string;
  /** The text as this layer holds it, the unsaved draft included. Empty where the layer sets none. */
  value: ReportText | undefined;
  maxLength: number;
  setHere: boolean;
  pending: boolean;
  beneathSource: BeneathSource;
  /** The text the layer beneath prints, already resolved for the reader's language. */
  beneath: string;
  disabled: boolean;
  onChange: (value: ReportText) => void;
  onRevert: () => void;
}

/**
 * One text of a brand. The box holds only what this layer sets: left empty, the layer beneath
 * shows through, and the line under the box says with what. A team cannot blank a field of
 * the organization's, so emptying the box and the arrow come to the same thing.
 */
const BrandTextField: React.FC<Props> = ({
  label, value, maxLength, setHere, pending, beneathSource, beneath, disabled, onChange, onRevert,
}) => {
  const { t } = useLocalization();

  return (
    <div>
      <LocalizedTextField
        label={label}
        value={value ?? {}}
        onChange={onChange}
        maxLength={maxLength}
        optional
        carriedHint={t('ReportDesign_Text_OtherLanguage')}
        disabled={disabled}
      />
      <FieldOrigin
        setHere={setHere}
        pending={pending}
        beneathSource={beneathSource}
        beneath={beneath}
        onRevert={disabled ? undefined : onRevert}
      />
    </div>
  );
};

export default BrandTextField;
